module.exports = __webpack_public_path__ + "static/113627846-lunchtime-customers-eating-at-a-busy-restaurant-591dc73a4ae81cabeb6b7ee8b93c84a7.png";